import React, { memo, useCallback } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { AiChatTestIds } from '../../../../../AiChat.testIds';

import { formatTextContentCopyText } from './TextContent.utils';

const TextContent = ({ contentProps, onCopy }) => {
  const handleCopy = useCallback(() => {
    onCopy(formatTextContentCopyText(contentProps.text));
  }, [contentProps.text, onCopy]);

  return (
    <Typography
      component="p"
      data-testid={AiChatTestIds.BOT_MESSAGE_TEXT_CONTENT}
      variant="regular14"
      onClick={handleCopy}
    >
      {contentProps.text}
    </Typography>
  );
};

TextContent.propTypes = {
  contentProps: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }).isRequired,
  onCopy: PropTypes.func.isRequired,
};

export default memo(TextContent);
